import CalorieIntakeChart from './CalorieIntakeChart';

export default CalorieIntakeChart;
